import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LoginService } from '../login.service';
import { BlockService } from '../block.service';

@Component({
    selector: 'app-block',
    templateUrl: './block.component.html',
    styleUrls: ['./block.component.scss'],
    standalone: false
})
export class BlockComponent implements OnInit {
  @Output() closed = new EventEmitter<boolean>();
  @Input('event') event
  blockForm:UntypedFormGroup
  startOptionalsHours = [];
  showDeleteAlert=false;
  error;
  formattedDuration = { days: 0, hours: 0, minutes: 0 };

  constructor(private fb:UntypedFormBuilder,public ls:LoginService,public blockService:BlockService) { }

  ngOnInit(): void {

    this.resetBlockForm();
    this.blockForm.get('duration').valueChanges.subscribe(value => {
      this.formattedDuration = this.calculateDuration(value);
    });
    this.loadBlockForm()
    this.generateTimes(this.blockService.startDate);
    this.subscribeToFormChanges();
  }

  resetBlockForm(){
    this.blockForm = this.fb.group({
      AutoIndex:[''],
      blockStartDate:[''],
      startHour: [''], 
      duration: [''], 
      comment: [null], 
      UID:[''],
      blockEndDate:[''],
      endHour:['']
    });
  }

  
subscribeToFormChanges() {
  // Track changes on both start and end dates or hours
  const startDateControl = this.blockForm.get('blockStartDate');
  const startHourControl = this.blockForm.get('startHour');
  const endDateControl = this.blockForm.get('blockEndDate');
  const endHourControl = this.blockForm.get('endHour');

  startDateControl.valueChanges.subscribe(() => this.updateDuration());
  startHourControl.valueChanges.subscribe(() => this.updateDuration());
  endDateControl.valueChanges.subscribe(() => this.updateDuration());
  endHourControl.valueChanges.subscribe(() => this.updateDuration());
}


updateDuration() {
  const startValue = this.blockForm.get('blockStartDate').value;
  const startTime = this.blockForm.get('startHour').value;
  const endValue = this.blockForm.get('blockEndDate').value;
  const endTime = this.blockForm.get('endHour').value;

  if (startValue && startTime && endValue && endTime) {
    const startDate = new Date(startValue);
    const endDate = new Date(endValue);

    // Adjust the hours and minutes based on input
    const [startHours, startMinutes] = startTime.split(':');
    const [endHours, endMinutes] = endTime.split(':');
    startDate.setHours(+startHours, +startMinutes);
    endDate.setHours(+endHours, +endMinutes);

    // Calculate duration in minutes
    const durationInMinutes = (endDate.getTime() - startDate.getTime()) / 1000 / 60;
    this.blockForm.get('duration').setValue(durationInMinutes);
    this.formattedDuration = this.calculateDuration(durationInMinutes);
  }
}

  loadBlockForm(){
    this.initialStartBlockHour();
    this.initialEndBlockHour();
    this.blockForm.get('duration').setValue(this.blockService.duration);
    this.blockForm.get('blockStartDate').setValue(this.blockService.startDate);
    this.blockForm.get('blockEndDate').setValue(this.blockService.endDate);
    this.blockForm.get('UID').setValue(this.ls.doctor);

    if(this.event){
      this.blockForm.get('AutoIndex').setValue(this.blockService.AutoIndex)
      this.blockForm.get('UID').setValue(this.event.DocUID)
      this.blockForm.get('comment').setValue(this.event.comment)   
    }
  }

  
  initialEndBlockHour(){
    const endDate = this.blockService.endDate;
    if (endDate) {
      const hours = endDate.getHours().toString().padStart(2, "0");
      const minutes = endDate.getMinutes();
     const endHour = `${hours}:${minutes.toString().padStart(2, "0")}`; 
      this.blockForm.get('endHour').setValue(endHour) 
    }
  }


  initialStartBlockHour(){
    const startDate = this.blockService.startDate;
    if (startDate) {
      const hours = startDate.getHours().toString().padStart(2, "0");
      const minutes = startDate.getMinutes();
     const startHour = `${hours}:${minutes.toString().padStart(2, "0")}`; 
      this.blockForm.get('startHour').setValue(startHour) 
    }
  }

  async deleteBlock() {
    try {
      const result = await this.blockService.delete();
      if (result) {
        this.closeBlockModal();
      }
    } catch (error) {
      console.error('Error during the deletion process:', error);
    }
  }

  
  async updateBlock() {
    try {
      const result = await this.blockService.updateBlock(this.blockForm.value);
      if (result['status']=='ok') {
        this.error=false;
        this.closeBlockModal();

      }
    } catch (error) {
      console.error('Error during the update block:', error);
      this.error=true
    }
  }

  
  generateTimes(startDay) {
    const startHour = startDay.getHours();
    this.startOptionalsHours = [];
    for (let minute = 0; minute < 60; minute += 5) {
      let time = `${startHour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
      this.startOptionalsHours.push(time);
    }
  }

  closeBlockModal(){
   this.closed.emit()
  }

  saveBlock(){
    this.blockService.addBlock(this.blockForm.value).subscribe((data)=>{
    if (data['AutoIndex']){
      this.closeBlockModal()
    }
    })
  }



calculateDuration(durationInMinutes: number) {
  const minutesInADay = 60 * 24;
  const minutesInAnHour = 60;

  const days = Math.floor(durationInMinutes / minutesInADay);
  durationInMinutes -= days * minutesInADay;

  const hours = Math.floor(durationInMinutes / minutesInAnHour);
  durationInMinutes -= hours * minutesInAnHour;

  const minutes = durationInMinutes;

  return { days, hours, minutes };
}


ngOnDestroy(): void {


}

}
